import * as Turbo from '@hotwired/turbo'

// Where to go, said by a response instead of by a redirect.
//
// A redirect cannot name a page to Turbo. Turbo submits with `fetch`, fetch
// follows the redirect itself, and the Fetch spec strips the fragment from
// `response.url` — the only place Turbo reads a submission's destination. So an
// action that returns the author to one page of a long document loses which
// one, however the server spells its `Location`. Handed the address whole, as a
// string, Turbo visits it and scrolls to the anchor with its own machinery.
export function visitStreamAction () {
  const url = this.getAttribute('target')
  if (url) Turbo.visit(url)
}
